/**
 * The task fields a <Preference> tag reads, for the Import step: its
 * options list (`options="$field"`), which is a list and, with
 * `kind="image|audio|video"`, a list of media. Its <Context> and <Option>
 * children carry `value` and `kind`, which the platform already reads.
 * Mirrors waraka_extensions.preference.fields on the server.
 */
const KINDS: Record<string, string> = { image: "images", audio: "audio", video: "video" };

export const preferenceFields = (el: Element) => {
  if (el.tagName !== "Preference") return [];
  const listed = el.getAttribute("options") ?? "";
  if (!listed.startsWith("$")) return [];
  const kind = KINDS[(el.getAttribute("kind") ?? "").toLowerCase()] ?? "text";
  return [{ field: listed.slice(1), kind, list: true }];
};
